import styled from "styled-components";
import { MainBodyText, MainHeading, MainSection, MainWrapper } from "../../../components/01_config/MainStyles";
import { sizes } from "../../../components/01_config/Sizes";

import { colors } from "../../../components/01_config/Colors";

export const Wrapper = styled(MainWrapper)`

`

export const Section = styled(MainSection)`
    flex-direction: column;
`

export const Title = styled(MainHeading)`

`

export const MainText = styled(MainBodyText)`
    padding: 0 ${sizes.sections_mob_marginsides};
    z-index: 20;
    text-align: justify;
`

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 30px auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 0px 10px #d6c9c9;
  border-radius: 6px;
  box-sizing: border-box;
`;

export const TableHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 90px repeat(6, minmax(40px, 1fr));
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;

  @media (max-width: 800px) {
    grid-template-columns: 70px repeat(6, 1fr);
    font-size: 0.75rem;
  }
`;

export const HeaderCell = styled.div`
  text-align: center;
`;

export const LabelFull = styled.span`
  @media (max-width: 800px) {
    display: none;
  }
`;

export const LabelShort = styled.span`
  display: none;

  @media (max-width: 800px) {
    display: inline;
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 90px repeat(6, minmax(40px, 1fr));
  gap: 8px;
  align-items: center;
  margin-bottom: 6px;

  @media (max-width: 800px) {
    grid-template-columns: 70px repeat(6, 1fr);
  }
`;

export const LessonCell = styled.div`
  font-weight: 600;
  font-size: 0.9rem;

  @media (max-width: 800px) {
    font-size: 0.8rem;
  }
`;

const teacherColor = (status) => {
  if (status === 1) return colors.green;      // light green (your current)
  if (status === 2) return "#0b5d1e";         // dark green (pick your preferred)
  return "transparent";
};

const studentColor = (status) => {
  if (status === 1) return "#bdbdbd";         // light grey
  if (status === 2) return "#6b6b6b";         // dark grey
  return "transparent";
};

export const CellButton = styled.button`
  width: 24px;
  height: 24px;
  margin: 0 auto;
  border-radius: 4px;
  border: 2px solid ${colors.greyFrame};

  background-color: ${({ status, disabled }) =>
    disabled ? studentColor(status) : teacherColor(status)};

  color: ${({ status }) => (status === 0 ? "black" : "white")};
  font-size: 0.9rem;
  font-weight: 700;

  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  opacity: ${({ disabled, status }) => (disabled && status === 0 ? 0.5 : 1)};

  ${({ disabled }) =>
    disabled &&
    `
      pointer-events: none;
    `}

  &:hover {
    border-width: ${({ disabled }) => (disabled ? "2px" : "3px")};
  }

  &:active {
    transform: ${({ disabled }) => (disabled ? "none" : "translate(1px, 1px)")};
  }
`;
